import { Component,Output,ViewChild, EventEmitter, OnInit } from '@angular/core';
import { ExportsService } from "../../../../injections/exports.service";
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import * as moment from 'moment';

@Component({
  selector: 'export-users',
  templateUrl: '../../templates/partials/users-exports.html'
})
export class ExportUsersComponent implements OnInit{

    @ViewChild('dateFrom') dateFrom;
    @ViewChild('dateSince') dateSince;
    public headerData:object = {
        trademark: "NOMBRE COMERCIAL",
        legal_name: "RAZÓN SOCIAL",
        cif: "CIF",
        direccion: "DIRECCIÓN",
        email: "EMAIL",
        payment_method: "MÉTODO DE PAGO",
        IBAN: "IBAN",
        mangopay_user_id: "ID USUARIO MANGOPAY",
        mangopay_wallet_id: "ID WALLET MANGOPAY",
        mangopay_mandate_id: "ID MANDATO MANGOPAY"
    }
    public buttonDisabled = false;

    constructor(private exportsService: ExportsService){}

    public closeSibiling(event){
        //console.log(event);
        if(event == "desde"){
            this.dateSince.opened = false;
        }else if(event == "hasta"){
             this.dateFrom.opened = false;
        }
    }

    public exportUsers(){
        var dateIni = (this.dateFrom.formatDate != null) ? moment(this.dateFrom.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
        var dateEnd = (this.dateSince.formatDate != null) ? moment(this.dateSince.formatDate,"DD/MM/YYYY").format("YYYY-MM-DD") : '';
        this.buttonDisabled = true;
        this.exportsService.exportUsers(dateIni, dateEnd).subscribe(result => {
            window.open(result,'_blank');
            this.buttonDisabled = false;
        });
    }

    ngOnInit() {
        this.dateFrom.dt = moment().subtract(7, 'days').toDate();
        this.dateSince.dt = moment().add(7, 'days').toDate();
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/exports/components/dummy/users-exports.component.ts